export default __webpack_public_path__ + "static/media/danskgo-screenshot-03.af66aa6a.png";